export default "__VITE_ASSET__n5RcGfHM__"